import { pageRoutes } from './createRoutes/page.routes';
import { settingRoutes } from './createRoutes/settings.routes';
import { singleRoutes } from './createRoutes/single.routes';
import { unloggedRoutes } from './createRoutes/unlogged.routes';
import { Route404 } from './createRoutes/404.routes';
import { profRoutes } from './createRoutes/prof.routes';
import { publicShopRoutes } from './createRoutes/publicShop.routes';
import { IS_ELEVE, IS_PROF } from '../helpers/user/authorization';
import * as React from 'react';
import { AppPath } from './pages';

export interface Route {
  path: AppPath;
  component?: React.ComponentType<any>;
  external?: boolean;
}

let routes: Route[] = [
  ...singleRoutes,
  ...pageRoutes,
  ...unloggedRoutes,
  ...settingRoutes,
  ...Route404
];

routes = IS_PROF
  ? [...routes, ...profRoutes]
  : IS_ELEVE
  ? routes
  : [...unloggedRoutes, ...publicShopRoutes];

export default routes;
